import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {useParams} from 'react-router-dom';
import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {VendorManagePersonnelRouteService} from 'src/shared/services/RouterService/VendorManagePersonnelRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const VendorPersonnelCreatePage = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);
  const {vendorId} = useParams();

  const mode: ViewModeType = 'create';
  const router = new VendorManagePersonnelRouteService(false, mode, {
    view: 'overview',
    vendorId: String(vendorId),
  });

  return (
    <PersonnelForm
      mode={mode}
      userType={UserTypeEnum.Contractor}
      vendorId={+vendorId!}
      view={'overview'}
      enableEdit={true}
      router={router}
    />
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.VendorPersonnelCreate(':vendorId'),
  element: <VendorPersonnelCreatePage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default VendorPersonnelCreatePage;
